module.exports = __webpack_public_path__ + "static/img/11.4c37e19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/11.jpg
// module id = Ufve
// module chunks = 1